

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Card, Form, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaUser, FaLock, FaUserTie } from 'react-icons/fa';
import vyaparlogo from '../Images/vyaparlogo.png';
import { Link } from 'react-router-dom';


const Login = () => {
  const [form, setForm] = useState({ email: '', password: '', role: 'buyer' });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' }); // Clear error on change
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!form.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(form.email)) {
      newErrors.email = 'Invalid email format';
    }

    if (!form.password.trim()) {
      newErrors.password = 'Password is required';
    } else if (form.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }

    if (!['buyer', 'seller', 'admin'].includes(form.role)) {
      newErrors.role = 'Invalid role selected';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  

// const handleSubmit = async () => {
//   if (!validate()) return;

//   try {
//     const res = await axios.post('https://vyaparapi.emedha.in/api/auth/login', form);
//     alert(res.data.message || 'Login successful');
//     localStorage.setItem('token', res.data.token);
//     sessionStorage.setItem('user', JSON.stringify(res.data.user));
//       axios.get(`https://vyaparapi.emedha.in/api/auth/api/seller-profile/${res.data.user.id}`).then(res => {
//     if (res.data) {
//           sessionStorage.setItem("business_category", res.data.business_category);
   
      
//     }
//   });

//     const role = res.data.user.role.toLowerCase();
//     window.location.href = '/'; // Or use navigate('/dashboard') if inside Router
//   } catch (err) {
//     alert('Login failed. Please check your credentials.');
//   }
// };


// const handleSubmit = async () => {
//   if (!validate()) return;

//   try {
//     const res = await axios.post('https://vyaparapi.emedha.in/api/auth/login', form);
//     alert(res.data.message || 'Login successful');

//     localStorage.setItem('token', res.data.token);
//     sessionStorage.setItem('user', JSON.stringify(res.data.user));

//     const profileRes = await axios.get(
//       `https://vyaparapi.emedha.in/api/auth/api/seller-profile/${res.data.user.id}`
//     );

//     if (profileRes.data) {
//       sessionStorage.setItem("business_category", profileRes.data.business_category);
//     }

//     const role = res.data.user.role.toLowerCase();

//     // Redirect only after everything is done
//     window.location.href = '/'; // or use navigate('/')
//   } catch (err) {
//     alert('Login failed. Please check your credentials.');
//   }
// };

const handleSubmit = async () => {
  if (!validate()) return;

  try {
    const res = await axios.post(
      'https://vyaparapi.emedha.in/api/auth/login',
      form,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    alert(res.data.message || 'Login successful');
    localStorage.setItem('token', res.data.token);
    sessionStorage.setItem('user', JSON.stringify(res.data.user));

    const role = res.data.user.role.toLowerCase();

    // ✅ Only fetch seller profile if role is 'seller'
    if (role === 'seller') {
      const profileRes = await axios.get(
        `https://vyaparapi.emedha.in/api/auth/api/seller-profile/${res.data.user.id}`
      );

      if (profileRes.data) {
        sessionStorage.setItem("business_category", profileRes.data.business_category);
      }
    }

    window.location.href = '/';
  } catch (err) {
    console.error("Login error:", err);
    alert('Login failed. Please check your credentials.');
  }
};



  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center"
      style={{
        height: '100vh',
        background: 'linear-gradient(135deg, #ddd9d9, #ffffff)',
      }}
    >
      <motion.div
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, type: 'spring' }}
        style={{ width: '100%', maxWidth: '420px' }}
      >
        <Card
          style={{
            borderRadius: '20px',
            padding: '30px',
            backdropFilter: 'blur(15px)',
            background: 'rgba(255, 255, 255, 0.15)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 20px 50px rgba(0, 0, 0, 0.2), 0 0 0 0.5px rgba(255, 255, 255, 0.3)',
          }}
        >
          <Card.Body>
            <div className="text-center mb-4">
              <img src={vyaparlogo} alt="Vyapar Logo" style={{ width: '80px' }} />
              <h4 className="mt-3" style={{ color: '#952929', fontWeight: '600' }}>
                Vyapar Bidding Portal
              </h4>
              <p style={{ fontSize: '14px', color: '#333' }}>Login to your account</p>
            </div>

            <Form>
              <Form.Group className="mb-3">
                <Form.Label>
                  <FaUser className="me-2" />
                  Email
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  isInvalid={!!errors.email}
                  style={{ backgroundColor: 'rgba(255,255,255,0.3)' }}
                />
                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  <FaLock className="me-2" />
                  Password
                </Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter your password"
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  isInvalid={!!errors.password}
                  style={{ backgroundColor: 'rgba(255,255,255,0.3)' }}
                />
                <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>
                  <FaUserTie className="me-2" />
                       Select Role
                </Form.Label>
                <Form.Select
                  name="role"
                  value={form.role}
                  onChange={handleChange}
                  isInvalid={!!errors.role}
                  style={{ backgroundColor: 'rgba(255,255,255,0.3)' }}
                >
                  <option value="buyer">Buyer</option>
                  <option value="seller">Seller</option>
                    <option value="admin">Admin</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.role}</Form.Control.Feedback>
              </Form.Group>

              <Button
                className="w-100"
                onClick={handleSubmit}
                style={{
                  backgroundColor: '#952929',
                  borderColor: '#952929',
                  fontWeight: '600',
                  letterSpacing: '0.5px',
                  borderRadius: '8px',
                  boxShadow: '0 6px 15px rgba(149, 41, 41, 0.4)',
                }}
              >
                Login
              </Button>
            </Form>
            <div className="text-center mt-3">
  <span style={{ color: '#333', fontSize: '14px' }}>
    Don’t have an account?{' '}
    <Link to="/signup" style={{ color: '#952929', fontWeight: '600', textDecoration: 'none' }}>
      Sign up here
    </Link>
  </span>
</div>
          </Card.Body>
        </Card>
      </motion.div>
    </Container>
  );
};

export default Login;
